import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function NotFound() {
  return (
    <div className="pt-20 min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <div className="relative mb-8">
            <div className="absolute inset-0 flex items-center justify-center opacity-10">
              <img 
                src="https://wjwcuakqeesxnbjznajh.supabase.co/storage/v1/object/sign/images/ibomopen2025.png?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1cmwiOiJpbWFnZXMvaWJvbW9wZW4yMDI1LnBuZyIsImlhdCI6MTc0NDkzOTQzMiwiZXhwIjoxNzc2NDc1NDMyfQ.mmWexTyuYcA9LTq1l0_mm40xqptR3LssIEqUPCGOv4M" 
                alt="Ibom Open Logo" 
                className="w-64 h-64 object-contain"
              />
            </div>
            <h1 className="text-9xl font-display font-bold text-golf-gray relative z-10">404</h1>
          </div>
          
          <h2 className="text-3xl font-display font-bold text-golf-gray mb-4">
            Looks like you've landed in the rough!
          </h2>
          
          <p className="text-xl text-gray-600 mb-8">
            The page you're looking for seems to have gone out of bounds.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => window.history.back()} 
              className="modern-button-outline px-6 py-3 text-golf-orange flex items-center gap-2 w-full sm:w-auto justify-center"
            >
              <ArrowLeftIcon className="w-5 h-5" />
              <span>Go Back</span>
            </button>
            
            <Link 
              to="/" 
              className="modern-button px-6 py-3 text-white flex items-center gap-2 w-full sm:w-auto justify-center"
            >
              <HomeIcon className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
          </div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="mt-16 max-w-2xl mx-auto"
        >
          <div className="bg-golf-sand/50 rounded-xl p-6 text-center">
            <h3 className="text-lg font-semibold text-golf-gray mb-2">
              Looking for something specific?
            </h3>
            <p className="text-gray-600 mb-4">
              You might find what you need in one of these popular sections:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Link to="/about" className="text-golf-orange hover:text-golf-green transition-colors">
                About
              </Link>
              <Link to="/schedule" className="text-golf-orange hover:text-golf-green transition-colors">
                Schedule
              </Link>
              <Link to="/registration" className="text-golf-orange hover:text-golf-green transition-colors">
                Registration
              </Link>
              <Link to="/sponsors" className="text-golf-orange hover:text-golf-green transition-colors">
                Partners
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}